import { Button, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router';

// Display when the route doesn't exists.
const NotFound = ({
  statusOverride,
  subTitleOverride,
}: {
  statusOverride?: '403' | '404' | '500';
  subTitleOverride?: string;
}): JSX.Element => {
  const navigate = useNavigate();
  return (
    <Result
      status={statusOverride ?? '404'}
      title={statusOverride ?? '404'}
      subTitle={
        subTitleOverride ?? 'Sorry, the page you visited does not exist.'
      }
      extra={
        <Button
          type="primary"
          onClick={() => {
            navigate('/');
          }}
        >
          Back Home
        </Button>
      }
    />
  );
};

export default NotFound;
